import React from 'react';
import '../Style/Projects.css'; 
import AddressBar from '../Components/AddressBar';
import Navbar from '../Components/Navbar';
import CopyRightBar from '../Components/CopyRightBar';
import Whatsup from '../assests/images/whatsup.png'; 
import Arrow from '../Components/Arrow';
import Footer from '../Components/Footer';
import Line from '../assests/images/line.png';
import '@fortawesome/fontawesome-free/css/all.min.css';

const InternationalProjects = () => {
  const openWhatsAppChat = () => {
    window.open('https://wa.me/1234567890', '_blank'); // Replace 1234567890 with your WhatsApp number
  };

  return (
    <div>
      {/* Address Bar */}
      <AddressBar />
      {/* Navbar */}
      <Navbar />

      <div className="Projects-header">
        <div className="header-content">
          <h1>International Projects</h1>
        </div>
      </div>

      {/* Services Section */}
      <div className="container service">
        <h2>Completed Projects - Overseas</h2>
        <img src={Line} alt="line" className="clients-line" />

        {/* Service Details in List Format */}
        <div className="projects-list">
          <ul>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>

              </div>
              <div className="project-info">
                <h3>Siemens make relays configuration and testing at various sites in Nakawa, Bombo and Marble  at Uganda-International energy technik (U) Ltd </h3>
                <p>Location: Uganda</p>
              </div>
            </li>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>

              </div>
              <div className="project-info">
                <h3>Cable schedule preparation and estimation for various substation projects</h3>
                <p>Location: Nigeria</p>
              </div>
            </li>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>

              </div>
              <div className="project-info">
                <h3>Testing and Commissioning of 330/132/33 kV Substation</h3>
                <p>Location:  Damatur at Nigeria</p>
              </div>
            </li>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>

              </div>
              <div className="project-info">
                <h3>Testing and Commissioning of 330/132/33 kV Substation</h3>
                <p>Location:   Yola at Nigeria</p>
              </div>
            </li>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>
              </div>
              <div className="project-info">
                <h3>Testing & Commissioning of 1*60MVA 132/33 kV and 1*150MVA 330/132/33 kV  transformers & associated protections testing and commissioning at DAMA Substation</h3>
                <p>Location: Nigeria</p>
              </div>
            </li>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>
              </div>
              <div className="project-info">
                <h3>Testing and Commissioning of 132/33 kV AJAH mobile Substation </h3>
                <p>Location: Nigeria</p>
              </div>
            </li>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>
              </div>
              <div className="project-info">
                <h3>Testing and Commissioning of 132/33 kV  JEBBA mobile Substation</h3>
                <p>Location: Nigeria</p>
              </div>
            </li>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>
              </div>
              <div className="project-info">
                <h3>Testing and Commissioning of 225kV, Switching Station</h3>
                <p>Location: Nkolkoumou, Cameroon</p>
              </div>
            </li>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>
              </div>
              <div className="project-info">
                <h3>Testing and Commissioning of 225kV/33kV, Substation Station</h3>
                <p>Location: Oyomabang at Cameroon</p>
              </div>
            </li>
            <li>
              <div className="icon-style">
              <i className="fas fa-project-diagram"></i>
              </div>
              <div className="project-info">
                <h3>Testing and Commissioning of 225kV/90kV/33kV, Substation Station</h3>
                <p>Location: Nkolbission at Cameroon</p>
              </div>
            </li>
           

          </ul>
        </div>
      </div>

      {/* Footer */}
      <Footer />
      <CopyRightBar />

      {/* WhatsApp Icon */}
      <div className="whatsapp-icon" onClick={openWhatsAppChat}>
        <img src={Whatsup} alt="WhatsApp Icon" className="whatsapp-icon-img" />
      </div>

      {/* Arrow Icon */}
      <Arrow />
    </div>
  );
};

export default InternationalProjects;
